// import logo from './logo.svg';
import './App.css';
// import Layout from './compoents/Layout';
import {BrowserRouter , Routes , Route } from 'react-router-dom'
import Home from './pages/Home'
import Projects from './pages/Projects'
import Contact from './pages/Contact'
import Courses from './pages/Courses'
import Careers from './pages/Carrers';
// import AOS from 'aos';
import 'aos/dist/aos.css';
// import {Helmet} from "react-helmet";

function App() {
  return (
    <div className="App">
           {/* <Helmet>
                <title>TECHNOFORGEN</title>
                <meta
                name="description"
                content='Fast forward your carrier with technoforgen'/>
                <link rel="canonical" href="http:technoforgen.co.in" />
                <meta name="keywords"
                   content="Complete Solutin for UI/UX, Mobile Apps, Web Application"/>
            </Helmet> */}
         
         <BrowserRouter>
         
             <Routes>

                   <Route path='/' element={<Home/>}/>
                   <Route path='/services' element={<Projects/>}/>
                   <Route path='/courses' element={<Courses/>}/>
                   <Route path='/careers' element={<Careers/>}/>
                   <Route path='/contact' element={<Contact/>}/>

             </Routes>

         </BrowserRouter>

    </div>
  );
}

export default App;
